import React, { useEffect, useState, useCallback } from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map, fromJS } from 'immutable'
import { getBoundActions } from '../../actions/index'
import {
  updateUpstreamContextFromObject,
} from '../../services/upstream-context/index'
import { getPrimary } from '../../services/languages/index'
import { getNextEpisodes } from '../../services/tiles/index'
import TileV2 from '../Tile.v2/Tile.v2'

/**
 * Detail page next episode component
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {string} props.title - The title of the next episode
 * @returns {JSX.Element} DetailPageV3NextEpisode
 */

function DetailPageV3NextEpisode (props) {
  const {
    detailData = Map(),
    title,
    auth,
    user,
    upstreamContext,
    country,
  } = props

  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const seriesId = detailData.get('seriesId')
  const episodeContentId = detailData.get('contentId')

  const [loading, setLoading] = useState(false)
  const [nextEpisode, setNextEpisode] = useState(null)

  const loadNextEpisode = useCallback(async () => {
    if (!seriesId || !episodeContentId) {
      return
    }
    setLoading(true)
    setNextEpisode(null)
    try {
      const result = await getNextEpisodes({
        seriesId,
        id: episodeContentId,
        language: userLanguage,
        country,
        auth,
      })
      const firstTitle = result.titles && result.titles[0]
      if (firstTitle && !result._dataError) {
        setNextEpisode(fromJS(firstTitle))
      }
    } finally {
      setLoading(false)
    }
  }, [seriesId, episodeContentId, userLanguage, country, auth])

  useEffect(() => {
    loadNextEpisode()
  }, [loadNextEpisode])

  const item = loading || !nextEpisode ? fromJS({ id: -1 }) : nextEpisode

  return (
    <>
      {!!title && <p className="detail-page-v3__right-rail-title">
        {title}
      </p>}
      <div className="detail-page-v3__next-episode">
        <TileV2
          data={item}
          legacyData
          upstreamContext={updateUpstreamContextFromObject(
            upstreamContext,
            {
              contentType: item.get('contentType'),
              itemIndex: 1,
              contentId: item.get('id'),
            },
          )}
          adminTitle="Series Episodes"
          index={1}
        />
      </div>
    </>
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  upstreamContext: state.upstreamContext,
  country: state.auth.get('country'),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3NextEpisode)
